import {
    allFetch
} from "../Domain";

/**
 * @description 小鈴鐺
 */
export const HintBell = (() => {
    /**
     * @description 查詢通知
     */
    const HintBellLogSearch = async function (obj = {
        is_read: '',
        status: '',
        sps_code: '',
        is_notice_only: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('HintBell/HintBellLogSearch', obj);
    }

    /**
     * @description 提示鈴鐺紀錄已讀
     */
    const HintBellLogRead = async function (obj = {
        hbl_id: ''
    }) {
        return await allFetch('HintBell/HintBellLogRead', obj);
    }

    /**
     * @description 新增通知
     */
    const HintBellLogCreate = async function (obj = {
        ul_id: '',
        sps_name: '',
        json: ''
    }) {
        return await allFetch('HintBell/HintBellLogCreate', obj);
    }

    return {
        HintBellLogSearch,
        HintBellLogRead,
        HintBellLogCreate
    }
})();
